export const formatDateDisplay = (dateStr) => {
  if (!dateStr) return 'Select date';
  const date = new Date(dateStr + 'T00:00:00');
  return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' });
};

export const formatTimeDisplay = (time, duration) => {
  if (!time) return 'Select time';
  const [hours, minutes] = time.split(':').map(Number);
  const startDate = new Date();
  startDate.setHours(hours, minutes);
  const endDate = new Date(startDate.getTime() + duration * 60 * 60 * 1000);
  const fmt = (d) => d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  return `${fmt(startDate)} to ${fmt(endDate)}`;
};

import { customerUnitPrice } from './planningConstants';

export const formatPrice = (service) => {
  if (!service) return '';
  const { pricing_model } = service;
  // Always show customer-facing price (NOT wholesale base_price).
  const v = customerUnitPrice(service).toFixed(2);
  switch (pricing_model) {
    case 'flat_rate': return `$${v}`;
    case 'per_hour': return `$${v}/hr`;
    case 'per_person': return `$${v}/person`;
    case 'per_hour_per_person': return `$${v}/hr/person`;
    default: return `$${v}`;
  }
};
